function mobileSlider() {

  const mobileSlider = new Swiper('.js-mobile-slider', {
    loop: true,
    draggable: true,
    allowTouchMove: true,
    effect: 'slide',
    slidesPerView: 1,
    spaceBetween: 40,
    navigation: {
      nextEl: '.js-mobile-slider-next',
      prevEl: '.js-mobile-slider-prev',
    },
  });

}


export default mobileSlider;
